import React, { useMemo } from 'react'
import { Stack, ToggleButtonGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Status from 'components/global/Status'
import { trackEvent } from 'analytics'
import { CardHeader } from 'packages/ui/CardPreview'
import { getDeviceStatus, availableToBgColor, availableToColor, availableToTranslationKey, isRackType } from '../../../helpers'
import { HeaderContainer, DeviceTitle, StyledToggleButton } from './styles'

const Header = ({ device, activeTab, onTabChange }) => {
  const { t } = useTranslation()
  
  const status = useMemo(() => {
    const isRack = isRackType(device?.model?.type)
    
    if (isRack) {
      return {
        label: t(availableToTranslationKey('installed')),
        color: availableToColor('installed'),
        bgcolor: availableToBgColor('installed'),
      }
    }
    
    const deviceStatus = getDeviceStatus(device)
    const label = t(availableToTranslationKey(deviceStatus.level))
    return {
      label,
      color: availableToColor(device.available_level),
      bgcolor: availableToBgColor(device.available_level),
    }
  }, [device, t])

  const isParent = device.children && device.children.length > 0

  return (
    <CardHeader>
      <HeaderContainer isParent={isParent}>
        <Stack direction="column" alignItems="center" gap={2}>
          {device.model?.manufacturer?.toLowerCase() !== 'juniper' && (
            <Status
              status={status.label}
              color={status.color}
              bgcolor={status?.bgcolor}
              isUppercase={false}
              height={24}
              borderRadius="50px"
            />
          )}
          <DeviceTitle>
            {device?.label}
          </DeviceTitle>
        </Stack>

        {isParent && (
          <ToggleButtonGroup
            value={activeTab}
            exclusive
            onChange={(event, newTab) => {
              if (newTab !== null) {
                trackEvent('monitoring_device_tab_changed', { tab_name: newTab })
                onTabChange(newTab)
              }
            }}
            sx={{
              width: '100%',
              border: '2px solid #EFEFEF',
              borderRadius: '8px',
              background: '#fff',
              position: 'relative',
            }}
          >
            <StyledToggleButton value="informations">
              {t('supervision.card.informations')}
            </StyledToggleButton>
            <StyledToggleButton value="group">
              {t('supervision.card.groupe')}
            </StyledToggleButton>
          </ToggleButtonGroup>
        )}
      </HeaderContainer>
    </CardHeader>
  )
}

export default Header